<template>
  <div>
    <MainSiteNav :content="content.mainSiteNav" v-bind="{ setHasShade }" class="mainSiteNav" />
    <div class="shadeContainer" :class="{ hasShade }">
      <PencilBanner v-if="pencilBanner" :content="pencilBanner" />
      <slot />
      <MainSiteFooter />
    </div>
    <LocaleSelectModal />
    <WizardFormModal v-bind="{ brand }" />
  </div>
</template>

<script setup>
import { ref } from 'vue'

import LocaleSelectModal from './LocaleSelectModal/index.vue'
import MainSiteFooter from './MainSiteFooter/index.vue'
import MainSiteNav from './MainSiteNav/index.vue'
import PencilBanner from './PencilBanner.vue'
import WizardFormModal from './WizardFormModal.vue'

const { content } = defineProps({
  content: {
    type: Object,
    default: () => ({}),
  },
})

const hasShade = ref(false)
const setHasShade = function (value) {
  hasShade.value = value
}

const brand = content.brand || (content.locale === 'en-US' ? 'inseego' : 'inseegoFleet')

const pencilBanner = content.pencilBanner || content.defaultPencilBanner
</script>

<style scoped>
.shadeContainer {
  position: relative;
}
.shadeContainer.hasShade::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;  /* Must be at least the z-index of the in-page sticky nav */
  background-color: rgba(0, 0, 0, 0.2);
}
.mainSiteNav {
  position: relative;
  z-index: 30;
}
</style>
